import { render, staticRenderFns } from "./OperaDeclareHistoryWindow.vue?vue&type=template&id=b91ea1a6&"
import script from "./OperaDeclareHistoryWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDeclareHistoryWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports